// extracted by mini-css-extract-plugin
export var standaloneTable = "_gp-0";
export var standaloneTableWithBodyFill = "_gp-1";
export var withExtraHeader = "_gp-2";